import { Component } from '@angular/core';
import {
    UilabMatFormFieldModule,
    UilabMatInputModule,
} from '@uilab/ng-mat-components';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface TextFieldExample {
    readonly variant: 'filled' | 'outlined';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
    readonly appearance: 'fill' | 'outline';
}

@Component({
    selector: 'avd-text-field-examples',
    templateUrl: './text-field-examples.component.html',
    styleUrls: ['./text-field-examples.component.scss'],
    imports: [
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabMatFormFieldModule,
        UilabMatInputModule,
    ],
})
export class TextFieldExamplesComponent {
    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink =
        'https://calm-mushroom-0d2458d1e.2.azurestaticapps.net/?path=/story/components-form-controls-input--default';
    readonly repoLink =
        'https://dev.azure.com/AVEVA-VSTS/UX/_git/uilab-base?version=GBfeat/angular-material-components&path=/projects/components/src/lib/input';

    readonly examples: readonly TextFieldExample[] = [
        {
            variant: 'filled',
            label: 'Filled Text Field',
            description:
                'Use a filled text field to emphasize data entry in dense forms and surfaces.',
            htmlSnippet: `<uilab-mat-form-field appearance="fill">
  <uilab-mat-label>Label</uilab-mat-label>
  <input uilabMatInput type="text" aria-label="Filled text field" />
</uilab-mat-form-field>`,
            appearance: 'fill',
        },
        {
            variant: 'outlined',
            label: 'Outlined Text Field',
            description:
                'Use an outlined text field to keep stronger separation between field boundaries and surrounding content.',
            htmlSnippet: `<uilab-mat-form-field appearance="outline">
  <uilab-mat-label>Label</uilab-mat-label>
  <input uilabMatInput type="text" aria-label="Outlined text field" />
</uilab-mat-form-field>`,
            appearance: 'outline',
        },
    ];
}
